import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useWiserTheme } from "../hooks/useWiserTheme";
import {
  getReusableTabsSx,
  getReusableTabSx,
} from "../shared/theme/wiserThemeHelpers";

export interface TabItem {
  label: string;
  content: React.ReactNode;
  icon?: React.ReactElement;
}

export interface ReusableTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  tabs: TabItem[];
  tabSx?: object;
  tabsSx?: object;
  toolbar?: React.ReactNode;
}

const ReusableTabs: React.FC<ReusableTabsProps> = ({
  value,
  onChange,
  tabs,
  tabSx,
  tabsSx,
  toolbar,
}) => {
  const { darkModeActive } = useWiserTheme();

  return (
    <Box sx={{ minWidth: 0, overflow: "hidden" }}>
      <Tabs
        value={value}
        onChange={onChange}
        sx={{
          ...getReusableTabsSx(darkModeActive),
          ...tabsSx,
        }}
      >
        {tabs.map((tab, idx) => (
          <Tab
            key={idx}
            icon={tab.icon}
            iconPosition="start"
            label={tab.label}
            sx={{
              ...getReusableTabSx(darkModeActive),
              ...tabSx,
            }}
          />
        ))}
      </Tabs>
      {toolbar ? (
        <Box sx={{ minWidth: 0, pt: 1, pb: 0.5, overflow: "visible", position: "relative" }}>
          {toolbar}
        </Box>
      ) : null}
      {tabs.map((tab, idx) => (
        <div
          key={idx}
          role="tabpanel"
          hidden={value !== idx}
          id={`tabpanel-${idx}`}
          aria-labelledby={`tab-${idx}`}
        >
          {value === idx && <Box sx={{ pt: 3, minWidth: 0, overflow: "hidden" }}>{tab.content}</Box>}
        </div>
      ))}
    </Box>
  );
};

export default ReusableTabs;
